/*
    Store module mutations examples

*/

// Boilerplate for generic mutations use in almost any module
import * as generic from '@/store/generic/mutations/result-status.js'

export function clearError (state, payload) {
  generic.clearError(state, payload)
}

export function setError (state, payload) {
  generic.setError(state, payload)
}

export function setSuccess (state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing (state, payload) {
  generic.setProcessing(state, payload)
}

export function setInitializing (state, payload) {
  generic.setInitializing(state, payload)
}


// Start new mutation here
// eslint-disable-next-line no-unused-vars
export function setBorrower (state, payload) {
  state.borrower = payload
}

export function setBorrowerSearch (state, payload) {
  state.borrowerSearch = payload
}

export function setBorrowerWithOutAuth (state, payload) {
  state.borrower = payload
}

export function setBorrowers (state, payload) {
  state.borrowers = payload
}

export function setBorrowersIsUnApproved (state, payload) {
  state.borrowersIsUnApproved = payload
}

export function setBorrowerOptions (state, payload) {
  state.borrowerOptions = payload
}

export function setBorrowerContractOptions (state, payload) {
  state.borrowerContractOptions = payload
}

export function delBorrower (state, payload) {
  state.borrowers = state.borrowers.filter(res => res.id !== payload.id)
  state.borrowerOptions = state.borrowerOptions.filter(res => res.id !== payload.id);
  state.borrowerContractOptions = state.borrowerContractOptions.filter(res => res.id !== payload.id);
  state.borrowersIsUnApproved = state.borrowersIsUnApproved.filter(res => res.id !== payload.id)
}

export function setSurety (state, payload) {
  state.surety = payload
}

export function setSuretySearch (state, payload) {
  state.suretySearch = payload
}

export function setSureties (state, payload) {
  state.sureties = payload
}

export function setSuretyOptions (state, payload) {
  state.suretyOptions = payload
}

export function setSuretyContractOptions (state, payload) {
  state.suretyContractOptions = payload
}

export function delSurety (state, payload) {
  state.sureties = state.sureties.filter(res => res.id !== payload.id)
  state.suretyOptions = state.suretyOptions.filter(res => res.id !== payload.id);
  state.suretyContractOptions = state.suretyContractOptions.filter(res => res.id !== payload.id);
}
